import { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Alert, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function MedicareReportForm({ location }) {
  console.log('MedicareReportForm rendered: ', location)

  let init = {
    settlementDateFrom: '',
    settlementDateTo: '',
    showCheck: '',
    showPlaintiffCounsel: '',
    checkNumberNull: '',
    beginExposureDateFrom: '',
    beginExposureDateTo: '',
    endExposureDateFrom: '',
    endExposureDateTo: '',
    amountOperator: '>',
    amount: ''
  }

  const navigate = useNavigate()
  init = initialFormValues('MedicareReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  const [formFeedback, setFormFeedback] = useState({})

  // Scroll error messages into view
  const scrollRef = useRef(null)
  useEffect(() => {
    console.log('userEffect: ', formFeedback, scrollRef)
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView()
    }
  }, [formFeedback])

  async function submitSearch() {
    console.log('MedicareReportForm.submitSearch', inputs)

    let validInput = false
    for (let input in inputs) {
      if (input.includes('Date') && inputs[input]) {
        if (inputs[input].length && inputs[input].length > 0) {
          validInput = true
        }
      }
    }
    if (!validInput) {
      return setFormFeedback({ noInput: <tr ref={scrollRef}><td colSpan={2}><Alert className='custom-alert' color='danger' style={{display: 'block', textAlign: 'center', margin: 'auto'}}>At least one valid "From" and/or "To" date must be specified.</Alert></td></tr>})
    }
    if (inputs['showCheck'] === 'on') {
      inputs['showCheck'] = 'Y'
    }
    if (inputs['showPlaintiffCounsel'] === 'on') {
      inputs['showPlaintiffCounsel'] = 'Y'
    }
    setFormFeedback({})
    submitFormValues('MedicareReportForm', navigate, inputs, 'medicare.medicare_revised')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText={'Medicare Report'} />
            {formFeedback.noInput}
            <tbody>
              <DateRangeInput label='Settlement Date' name='settlementDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.settlementDateFrom} defaultValueTo={inputs.settlementDateTo} />
              <tr>
                <td><b>Display</b></td>
                <td>
                  <Input className="custom-checkbox" type="checkbox" defaultChecked={inputs.showCheck} name="showCheck" onChange={handleInputChange} /> Check Number <span><br /></span>
                  <Input className="custom-checkbox" type="checkbox" defaultChecked={inputs.showPlaintiffCounsel} name="showPlaintiffCounsel" onChange={handleInputChange} /> Plaintiff Counsel <span><br /></span>
                </td>
              </tr>
              <tr>
                <td><b>Check Number</b></td>
                <td>
                  <Input bsSize="sm" style={{ width: 'auto', display: 'inline-block' }} type="select" name="checkNumberNull" className="operator-input" onChange={handleInputChange} defaultValue={inputs.checkNumberNull}>
                    <option key={0} value={''}></option>
                    <option key={1} value={'IS NULL'}>Is Null</option>
                    <option key={2} value={'IS NOT NULL'}>Is Not Null</option>
                  </Input>
                </td>
              </tr>
              <tr>
                <td><b>Settlement Amount</b></td>
                <td>
                  <Input bsSize="sm" style={{ width: 'auto', display: 'inline-block' }} type="select" name="amountOperator" className="operator-input" onChange={handleInputChange} defaultValue={inputs.amountOperator}>
                    <option key={0} value={'>'}>Greater Than</option>
                    <option key={1} value={'<'}>Less Than</option>
                  </Input>
                  <span style={{ paddingLeft: '20px' }}>$</span>
                  <Input bsSize="sm" style={{ width: 'auto', display: 'inline-block' }} type="select" name="amount" className="operator-input" onChange={handleInputChange} defaultValue={inputs.amount}>
                    <option key={0} value={''}></option>
                    <option key={1} value={'25000'}>25,000</option>
                    <option key={2} value={'5000'}>5,000</option>
                    <option key={3} value={'2000'}>2,000</option>
                    <option key={4} value={'1000'}>1,000</option>
                    <option key={5} value={'750'}>750</option>
                    <option key={6} value={'300'}>300</option>
                  </Input>
                </td>
              </tr>
              <DateRangeInput label='Total Beginning Exposure' name='beginExposureDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.beginExposureDateFrom} defaultValueTo={inputs.beginExposureDateTo} />
              <DateRangeInput label='Total End Exposure' name='endExposureDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.endExposureDateFrom} defaultValueTo={inputs.endExposureDateTo} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label='Run Report' />
      </form>
    </div>
  )
}
